import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import classNames from "classnames/bind";
import {
  Previous,
  List,
  PlusSolidIcon,
  SearchBlack,
  DeleteIcon,
  OnStatus,
  OffStatus,
  DownIcons,
  LoseConnectStatus,
  WeakConnectStatus,
} from "../../../../components/Icons/Icons";
import { InputTextBox, Loading, Toast } from "../../../../components";
import empty from "../../../../assets/images/Emty.png";
import ModalCamera from "../ModalCamera/ModalCamera";
import { groupCameraManagement } from "../../../../services/api/GroupCameraManagement";
import styles from "./AddGroup.module.css";
import { sorterArrayChildIsManyObj } from "../../../../utils";

const cx = classNames.bind(styles);
const AddGroup = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [listSelect, setListSelect] = useState([]);
  const [nameGroup, setNameGroup] = useState('');
  const [textSearch, setTextSearch] = useState();
  const [loading, setLoading] = useState(false);
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState()
  const handleClick = () => {
    setShowModal(true);
  };
  const handleClose = () => {
    setShowModal(false);
  };
  const handleOK = (item) => {
    setListSelect(prev => [...prev, ...item]);
  };
  const onChangeNameGroup = (data) => {
    setNameGroup(data);
  };
  const onChangeTextSearch = (data) => {
    setTextSearch(data);
  };
  const handleRemoveCamera = (code) => {
    const data = listSelect.filter((item) => item?.CAMERA?.CODE !== code);
    setListSelect(data);
  };

  // Tao nhom moi
  const handleAddGroup = async () => {
    setLoading(!loading)
    try {
      if (listSelect.length > 0) {
        const listCam = listSelect.map((item) => {
          return { camera_code: item?.CAMERA?.CODE, prioritized: "1" };
        });
        const data = JSON.stringify({
          subject_name: nameGroup && nameGroup?.trim().length > 0 ? nameGroup : 'Nhóm chưa đặt tên',
          node: "testNode",
          list_cam: { data: listCam },
        });
        await groupCameraManagement.add(
          "/groupCamera/post-add-groupCamera/",
          data
        );
        setLoading(false)
        Toast.open("Thêm mới nhóm camera thành công", "success");
        navigate(-1, { replace: true });
      } else {
        setLoading(false)
        Toast.open("Vui lòng chọn camera", "danger");
      }
    } catch (e) {
      if (e.response.status === 403) {
        setLoading(false)
        Toast.open("Bạn không có quyền thêm mới nhóm camera", "danger");
      }
      else {
        setLoading(false)
        Toast.open("Thêm mới nhóm camera không thành công", "danger");
      }
    }
  };
  useEffect(() => {
    const newData = listSelect ? listSelect : null
    if (newData) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArrayChildIsManyObj(newData, 'CAMERA', 'NAME_CAM')
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArrayChildIsManyObj(newData, 'CAMERA', 'NAME_CAM')
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    }
  }, [listSelect, toggleSort])

  const handleSort = (type) => {
    if (type !== toggleSort) {
      setToggleSort(type)
    } else {
      setToggleSort(false)
    }
  }

  const handleCancel = () => {
    navigate(-1, { replace: false })
  }

  // // console.log(dataTable);

  return (
    <>
      {showModal && (
        <ModalCamera
          onClose={handleClose}
          listCam={listSelect}
          onOK={handleOK}
        />
      )}
      <div className={cx("group")}>
        <div className={cx("header")}>
          <span className={cx("icon")}>
            <Link to="/admin/camera_group">
              <Previous />
            </Link>
          </span>
          <h1 className={cx("title")}>Tạo nhóm mới</h1>
        </div>
        <div className={cx("content")}>
          <div className={cx("form-add")}>
            <div className={cx("header", "sub")}>
              <h1 className={cx("title", "sub-title")}>Thông tin chung</h1>
            </div>
            <div className={cx("form")}>
              <InputTextBox
                style={{ marginBottom: 16 }}
                type="text"
                placeholder="Nhập"
                title="Tên nhóm camera"
                onChange={onChangeNameGroup}
                value={nameGroup}
              />
            </div>
          </div>
          <div className={cx("list-camera")}>
            <div className={cx("header", "sub")}>
              <h1 className={cx("title", "sub-title")}>Camera</h1>
            </div>
            <div className={cx("search")}>
              <div className={cx("title-list")}>
                <List />
                <button onClick={handleClick} className={cx('button-show-list-camera')}>Xem danh sách Camera</button>
              </div>
              <div className={cx("search-form")}>
                <InputTextBox
                  style={{ paddingTop: 2 }}
                  type="text"
                  placeholder="Tìm kiếm"
                  className={cx("pd")}
                  value={textSearch}
                  onChange={onChangeTextSearch}
                />
                <span className={cx("icon-search")}>
                  <SearchBlack />
                </span>
              </div>
            </div>
            <div className={cx("list")}>
              {dataTable && dataTable.length ? (
                <div
                  className={cx("content-table")}
                  style={{ padding: "0 16px" }}
                >
                  <table className={cx("table")}>
                    <thead>
                      <tr>
                        <th>STT</th>
                        <th>
                          Tên camera
                          {/* <button className={cx('button-fill-name-down')} onClick={() => handleSort('down')}><DownIcons /></button>
                          <button className={cx('button-fill-name-up')} onClick={() => handleSort('up')}><DownIcons /></button> */}
                        </th>
                        {/* <th>Nhóm </th> */}
                        <th>Địa điểm</th>
                        <th>Độ phân giải</th>
                        <th>Dịch vụ</th>
                        <th>Hành động</th>
                      </tr>
                    </thead>
                    <tbody>
                      {dataTable &&
                        dataTable.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                <div style={{
                                  display: "flex",
                                  gap: 10,
                                  alignItems: "center",
                                  padding: "14px 0",
                                }}>
                                  <span className={cx('On')}>
                                    {item?.CAMERA?.STATUS_ACTIVE === 0 ? <OnStatus /> :
                                      item?.CAMERA?.STATUS_ACTIVE === 1 ? <LoseConnectStatus /> :
                                        item?.CAMERA?.STATUS_ACTIVE === 2 ? <WeakConnectStatus /> :
                                          <OffStatus />
                                    }
                                    <p className={cx('tooltip')}>
                                      {item?.CAMERA?.MESSAGE}
                                    </p>
                                  </span>
                                  <span style={{ fontSize: 14 }}>
                                    {item?.CAMERA?.NAME_CAM}
                                  </span>
                                </div>
                              </td>
                              {/* <td>{item?.CAMERA?.GROUP_NAME}</td> */}
                              <td>{item?.CAMERA?.PROVINCE_NAME}</td>
                              <td>{item?.CAMERA?.MAIN_SOURCE}</td>
                              <td></td>
                              <td>
                                <button
                                  onClick={(e) =>
                                    handleRemoveCamera(item?.CAMERA.CODE)
                                  }
                                >
                                  <DeleteIcon />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className={cx("content-faild")}>
                  <img src={empty} alt="Không có nội dung tìm kiếm" />
                  <p className={cx("description")}>
                    Chưa có camera nào trong nhóm
                  </p>
                </div>
              )}
              <div className={cx("content-faild", "no-padding")}>
                <button onClick={handleClick} className={cx("btn-camera")}>
                  Thêm camera{" "}
                  <span style={{ paddingTop: 2 }}>
                    <PlusSolidIcon />
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className={cx("footer")}>
          <button onClick={handleAddGroup} className={cx("btn-add")}>
            Tạo mới
          </button>
          <button className={cx("btn-cancel")} onClick={handleCancel}>Hủy bỏ</button>
        </div>
      </div>
      {loading && (
        <div className={cx('loading-modal')}>
          <Loading />
        </div>
      )}
    </>
  );
};

export default AddGroup;
